'use client';

import { useEffect } from 'react';
import { useHtmlHeadState } from '../HtmlHeadProvider';

export interface OnPageBlurProps {
    blurCallback: () => void;
    delay: number;
    timeoutCallback: () => void;
}

export function useOnPageBlur({ blurCallback, delay, timeoutCallback }: OnPageBlurProps) {
    const { registerBlurHandler, unregisterBlurHandler } = useHtmlHeadState();

    useEffect(() => {
        let timeout: number;
        const blurHandler = () => {
            blurCallback();
            const callback = () => {
                timeoutCallback();

                timeout = window.setTimeout(callback, delay);
            };
            callback();

            return () => {
                window.clearTimeout(timeout);
            };
        };
        registerBlurHandler(blurHandler);

        return () => {
            window.clearTimeout(timeout);
            unregisterBlurHandler(blurHandler);
        };
    }, [blurCallback, delay, registerBlurHandler, timeoutCallback, unregisterBlurHandler]);
}
